
import ScatterPlot from "./ScatterPlot";

const categoryColors = {
  Success: "#117733",
  Excess: "#0072B2",
  Marginal: "#d6cf04",
  Insufficient: "#E69F00",
  Failure: "#661100",
  "Check Data": "#E69F00",
  "Small Storm With Bypass": "#800080"
};

// a kind of global constant for the Hydrology index uncertainty buffer (Elizabeth and Eddie determined 0.2 last time they talked about it)
// and it has been 0.2 for a while now
const UNCERTAINTY_BUFFER = 0.2;

export default function HydrologyScatterPlot({ data }) {
  
  return (
    <ScatterPlot
      data={data}
      xAccessor={d => d.precip_design_ratio}
      yAccessor={d => d.volreduc_ratio}
      xLabel="Precipitation Depth to Design Ratio"
      yLabel="Volume Retention Ratio"
      referenceLines={[
        { type: "horizontal", value: 0.8 },
        { type: "horizontal", value: 1.2 },
        { type: "vertical", value: 1, segment: true, yMin: 0, yMax: 0.8 },
        { type: "vertical", value: 1, segment: true, yMin: 1.2, yMax: Infinity }
      ]}
      colorAccessor={d => categoryColors[d.category] || "#3182ce"}
      symbolAccessor={d => ({
        shape: "circle",
        fill: d.is_comparison !== 'true'
      })}
      tooltipRenderer={tooltip => (
        <div
          className="absolute z-50 bg-white border border-gray-300 rounded shadow-lg px-3 py-2 text-xs pointer-events-none"
          style={{ left: tooltip.x + 12, top: tooltip.y + 12, minWidth: 220 }}
        >
          <div><b>Category:</b> {tooltip.d.category}</div>
          <div><b>Volume Retention Ratio:</b> {!isNaN(Number(tooltip.d.volreduc_ratio)) ? Number(tooltip.d.volreduc_ratio).toFixed(3) : tooltip.d.volreduc_ratio}</div>
          <div><b>Precipitation Depth to Design Ratio:</b> {!isNaN(Number(tooltip.d.precip_design_ratio)) ? Number(tooltip.d.precip_design_ratio).toFixed(3) : tooltip.d.precip_design_ratio}</div>
          <div><b>Retained Volume:</b> {(() => { const val = Number(tooltip.d.inflow_volume || 0) - Number(tooltip.d.outflow_volume || 0); return !isNaN(val) ? val.toFixed(3) : val; })()} {tooltip.d.volume_units}</div>
          <div><b>Design Capture Volume:</b> {!isNaN(Number(tooltip.d.design_capture_volume)) ? Number(tooltip.d.design_capture_volume).toFixed(3) : tooltip.d.design_capture_volume} {tooltip.d.design_capture_volume_units}</div>
        </div>
      )}
    />
  );
} 